webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(30)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(61),
  /* scopeId */
  "data-v-27c33754",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(39)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(70),
  /* scopeId */
  "data-v-940c8cfa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_home__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_home___default.a
  }]
}));

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonp__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    projectTitle: '',
    username: '',
    shields: [],
    showcaseImages: [],
    projectDescription: '',
    dependencies: [],
    projectInstallation: '',
    projectHowToUse: '',
    examples: [],
    contributing: '',
    motivation: '',
    architecture: '',
    documentation: '',
    license: -1,
    contributors: [],
    showVueReadme: false,
    finalMarkdown: ''
  },
  actions: {},
  mutations: {
    UPDATE_PROJECT_TITLE: function updateProjectTitle(state, payload) {
      state.projectTitle = payload;
    },
    UPDATE_USERNAME: function updateUsername(state, payload) {
      state.username = payload;
    },
    UPDATE_SHIELDS: function updateShields(state, payload) {
      state.shields.push({
        name: payload.name,
        value: payload.value,
        url: payload.url,
        style: payload.style,
        color: payload.color
      });
    },
    UPDATE_PROJECT_DESCRIPTION: function updateDescription(state, payload) {
      state.projectDescription = payload;
    },
    ADD_DEPENDENCY: function addDependency(state, payload) {
      state.dependencies.push(payload.dependency);
    },
    DELETE_DEPENDENCY: function deleteDependency(state, payload) {
      state.dependencies.splice(payload.index, 1);
    },
    UPDATE_INSTALLATION: function updateInstallation(state, payload) {
      state.projectInstallation = payload;
    },
    UPDATE_HOW_TO_USE: function updateHowToUse(state, payload) {
      state.projectHowToUse = payload;
    },
    UPDATE_LICENSE: function updateLicens(state, payload) {
      state.license = payload;
    },
    UPDATE_CONTRIBUTORS: function updateContributors(state) {
      if (state.username !== '' && state.projectTitle !== '') {
        __WEBPACK_IMPORTED_MODULE_2_jsonp___default()('https://api.github.com/repos/' + state.username + '/' + state.projectTitle + '/contributors', null, function (err, data) {
          if (err) {
            return;
          }
          state.contributors = data.data;
        });
      }
    },
    UPDATE_SHOW_VUE_README: function showVueReadme(state, payload) {
      state.showVueReadme = payload;
    },
    ADD_SHOWCASE_IMAGE: function addShowcaseImage(state, payload) {
      state.showcaseImages.push(payload);
    },
    DELETE_SHOWCASE_IMAGE: function deleteShowcaseImage(state, payload) {
      state.showcaseImages.push(payload);
    },
    ADD_EXAMPLE: function addExample(state, payload) {
      state.examples.push(payload);
    },
    UPDATE_CONTRIBUTING: function updateContributing(state, payload) {
      state.contributing = payload;
    },
    UPDATE_MOTIVATION: function updateMotivation(state, payload) {
      state.motivation = payload;
    },
    UPDATE_ARCHITECTURE: function updateArchitecture(state, payload) {
      state.architecture = payload;
    },
    UPDATE_DOCUMENTATION: function updateDocumentation(state, payload) {
      state.documentation = payload;
    },
    UPDATE_FINAL_MARKDOWN: function updateFinalMarkdown(state, payload) {
      state.finalMarkdown = payload;
    }
  },
  getters: {}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(34)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(65),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "router", function() { return __WEBPACK_IMPORTED_MODULE_2__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "store", function() { return __WEBPACK_IMPORTED_MODULE_3__store__["a"]; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return app; });






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});



/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_navbar__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_0__components_navbar___default.a
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'configurator-checkbox',
  props: {
    text: String,
    storeProperty: String,
    storeCommitEvent: String
  },
  computed: {
    checked: {
      get: function getChecked() {
        return this.$store.state[this.storeProperty];
      },
      set: function setChecked(value) {
        this.$store.commit(this.storeCommitEvent, value);
      }
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_vue_r_button__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'configurator-contact',
  components: {
    'vue-button': __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button___default.a
  },
  data: function data() {
    return {
      selectedShield: 0,
      shieldOptions: [{ text: 'Flat', value: 0 }, { text: 'Plastic', value: 1 }, { text: 'Flat-Squared', value: 2 }, { text: 'Social', value: 3 }]
    };
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_vue_r_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_configuratorInput__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_configuratorInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_configuratorInput__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'configurator-documentation',
  components: {
    'vue-r-button': __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button___default.a,
    'configurator-input': __WEBPACK_IMPORTED_MODULE_1__components_configuratorInput___default.a
  },
  methods: {
    addDocumentationUrl: function addDocumentationUrl() {
      this.$store.commit('UPDATE_DOCUMENTATION', this.$refs.documentationUrlInput.storeValue);
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_configuratorInput__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_configuratorInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_configuratorInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vue_r_button__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vue_r_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_vue_r_button__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  components: {
    'configurator-input': __WEBPACK_IMPORTED_MODULE_0__components_configuratorInput___default.a,
    'vue-r-button': __WEBPACK_IMPORTED_MODULE_1__components_vue_r_button___default.a
  },
  data: function data() {
    return {
      nameError: false,
      urlError: false
    };
  },

  methods: {
    addExample: function addExample() {
      var name = this.$refs.inputName.storeValue;
      if (name === undefined || name === '') {
        return;
      }
      var value = this.$refs.inputUrl.storeValue;
      if (value === undefined || value === '') {
        return;
      }
      var payload = {
        name: this.$refs.inputName.storeValue,
        url: this.$refs.inputUrl.storeValue
      };
      this.$store.commit('ADD_EXAMPLE', payload);
      this.$refs.inputName.storeValue = '';
      this.$refs.inputUrl.storeValue = '';
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'configurator-input',
  props: {
    title: String,
    placeholder: String,
    storeProperty: String,
    storeCommitEvent: String
  },
  data: function data() {
    return {
      backupModel: ''
    };
  },

  computed: {
    storeValue: {
      get: function get() {
        if (this.storeProperty !== undefined) {
          return this.$store.state[this.storeProperty];
        }
        return this.backupModel;
      },
      set: function set(value) {
        if (this.storeCommitEvent !== undefined) {
          this.$store.commit(this.storeCommitEvent, value);
        } else {
          this.backupModel = value;
        }
      }
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_vue_r_button__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    'vue-r-button': __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button___default.a
  },
  computed: {
    dependencies: function computedDependencies() {
      return this.$store.state.dependencies;
    }
  },
  data: function data() {
    return {
      dependencyName: '',
      dependencyVersion: ''
    };
  },

  methods: {
    addDependency: function addDependency() {
      var dependency = {
        name: this.dependencyName,
        version: this.dependencyVersion
      };
      this.$store.commit({
        type: 'ADD_DEPENDENCY',
        dependency: dependency
      });
      this.dependencyName = '';
      this.dependencyVersion = '';
      this.$refs.dependencyNameInput.focus();
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_vue_r_button__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'configurator-shield',
  components: {
    'vue-button': __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button___default.a
  },
  data: function data() {
    return {
      shieldName: '',
      shieldValue: '',
      shieldUrl: '',
      shieldColor: '',
      selectedShield: 0,
      shieldOptions: [{ text: 'Flat', value: 0 }, { text: 'Plastic', value: 1 }, { text: 'Flat-Squared', value: 2 }, { text: 'Social', value: 3 }]
    };
  },

  methods: {
    addShield: function addShield() {
      var shield = {
        name: this.shieldName,
        value: this.shieldValue,
        url: this.shieldUrl,
        style: this.selectedShield,
        color: this.shieldColor
      };
      this.$store.commit('UPDATE_SHIELDS', shield);
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_configuratorInput__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_configuratorInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_configuratorInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vue_r_button__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vue_r_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_vue_r_button__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'configurator-showcase',
  components: {
    'configurator-input': __WEBPACK_IMPORTED_MODULE_0__components_configuratorInput___default.a,
    'vue-r-button': __WEBPACK_IMPORTED_MODULE_1__components_vue_r_button___default.a
  },
  computed: {
    urls: function getUrls() {}
  },
  methods: {
    addShowcaseImage: function addShowcaseImage() {
      this.$store.commit('ADD_SHOWCASE_IMAGE', this.$refs.inputField.storeValue);
      this.$refs.inputField.storeValue = '';
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'configurator-textarea',
  props: {
    title: String,
    placeholder: String,
    rows: Number,
    storeProperty: String,
    storeCommitEvent: String
  },
  computed: {
    projectDescription: {
      get: function get() {
        return this.$store.state[this.storeProperty];
      },
      set: function set(value) {
        this.$store.commit(this.storeCommitEvent, value);
      }
    }
  },
  methods: {
    adjustHeight: function adjustHeight(event) {
      var textarea = event.srcElement;
      textarea.style.height = '1px';
      var lineHeight = parseInt(window.getComputedStyle(textarea)['line-height'], 10);
      textarea.style.height = lineHeight + textarea.scrollHeight + 'px';
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_vue_r_button__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'readme-download-panel',
  components: {
    'vue-r-button': __WEBPACK_IMPORTED_MODULE_0__components_vue_r_button___default.a
  },
  methods: {
    closeModal: function closeModal() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  mounted: function mounted() {
    var menu = document.getElementById('menu');
    var WINDOW_CHANGE_EVENT = 'onorientationchange' in window ? 'orientationchange' : 'resize';

    function toggleHorizontal() {
      [].forEach.call(document.getElementById('menu').querySelectorAll('.custom-can-transform'), function (el) {
        el.classList.toggle('pure-menu-horizontal');
      });
    };

    function toggleMenu() {
      menu.classList.contains('open') ? setTimeout(toggleHorizontal, 500) : toggleHorizontal();
      menu.classList.toggle('open');
      document.getElementById('toggle').classList.toggle('x');
    };

    function closeMenu() {
      if (menu.classList.contains('open')) {
        toggleMenu();
      }
    }

    document.getElementById('toggle').addEventListener('click', function (e) {
      toggleMenu();
      e.preventDefault();
    });

    window.addEventListener(WINDOW_CHANGE_EVENT, closeMenu);
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'readme-preview',
  computed: {
    title: function getTitle() {
      return this.$store.state.projectTitle + ' by <a href="https://github.com/' + this.$store.state.username + '">' + this.$store.state.username + '</a>';
    },
    shields: function getShields() {
      if (this.$store.state.shields.length === 0) {
        return '';
      }
      var result = '<div style="text-align:center">';
      this.$store.state.shields.forEach(function (shield) {
        var userColor = shield.color;
        if (!userColor.includes('#')) {
          userColor = '#' + userColor;
        }
        var isColorCode = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(userColor);
        var color = '8477B7';
        if (isColorCode) {
          color = userColor.replace('#', '');
        }
        var styleDict = {
          0: '?style=flat',
          1: '?style=plastic',
          2: '?style=flat-square',
          3: '?style=social'
        };
        var url = 'https://img.shields.io/badge/' + shield.name + '-' + shield.value + '-' + color + '.svg' + styleDict[shield.style];
        var imageString = '<img src="' + url + '" alt="badge ' + shield.name + '" />';
        result += shield.url !== '' ? '<a href="' + shield.url + '">' + imageString + '</a> ' : imageString + ' ';
      });
      return result + '</div>';
    },
    showcase: function getShowcase() {
      if (this.$store.state.showcaseImages === undefined || this.$store.state.showcaseImages.length === 0) {
        return '';
      }
      var result = '<div style="text-align:center">';
      this.$store.state.showcaseImages.forEach(function (showcaseUrl) {
        result += '<img src ="' + showcaseUrl + '" />';
      });
      result += '</div>';
      return result;
    },
    linkToVueReadme: function getLinkToVueReadme() {
      if (this.$store.state.showVueReadme === true) {
        return '## This readme is powered by vue-readme\nCheck out vue-readme [[Website](https://igeligel.github.io/vue-readme) | [GitHub](https://github.com/igeligel/vue-readme)]';
      }
      return '';
    },
    description: function getDescription() {
      if (this.$store.state.projectDescription.length > 0) {
        return '## Description\n\n> ' + this.$store.state.projectDescription;
      }
      return '';
    },
    dependencies: function getDependencies() {
      if (this.$store.state.dependencies.length === 0) {
        return '';
      }
      var baseString = '## Dependencies\n\n| Dependency | Version |\n| -- | -- |\n';
      this.$store.state.dependencies.forEach(function (element) {
        baseString += '| ' + element.name + ' | ' + element.version + ' |\n';
      });
      return baseString;
    },
    installation: function getInstallation() {
      if (this.$store.state.projectInstallation.length > 0) {
        return '## Installation\n\n' + this.$store.state.projectInstallation;
      }
      return '';
    },
    howToUse: function getHowToUse() {
      if (this.$store.state.projectHowToUse.length > 0) {
        return '## How To Use\n\n' + this.$store.state.projectHowToUse;
      }
      return '';
    },
    examples: function getExamples() {
      if (this.$store.state.examples.length > 0) {
        var result = '## Examples\n';
        this.$store.state.examples.forEach(function (example) {
          result += '- [' + example.name + '](' + example.url + ')\n';
        });
        return result;
      }
      return '';
    },
    contributing: function getContributing() {
      if (this.$store.state.contributing.length > 0) {
        return '## Contributing\n\n' + this.$store.state.contributing;
      }
      return '';
    },
    resourcesHeading: function getResourcesHeading() {
      var state = this.$store.state;
      var motivation = state.motivation,
          architecture = state.architecture,
          documentation = state.documentation;

      if (motivation.length > 0 || architecture.length > 0 || documentation.length > 0) {
        return '## Resources';
      }
      return '';
    },
    motivation: function getMotivation() {
      if (this.$store.state.motivation.length > 0) {
        return '### Motivation\n\n' + this.$store.state.motivation;
      }
      return '';
    },
    architecture: function getArchitecture() {
      if (this.$store.state.architecture.length > 0) {
        return '### Architecture\n\n' + this.$store.state.architecture;
      }
      return '';
    },
    documentation: function getDocumentation() {
      if (this.$store.state.documentation.length > 0) {
        return '### Documentation\n\n> You can find documentation [here](' + this.$store.state.documentation + ').';
      }
      return '';
    },
    createLicenseText: function createLicenseText() {
      if (this.$store.state.projectTitle === undefined || this.$store.state.projectTitle === '') {
        return '';
      }
      if (this.$store.state.license === -1) {
        return '';
      }
      var licenseDict = {
        0: 'MIT',
        1: 'BSD',
        2: 'GPL'
      };
      return '\n## License\n\n*' + this.$store.state.projectTitle + '* is realeased under the ' + licenseDict[this.$store.state.license] + ' License.';
    },
    createContributorHtml: function createContributorHtml() {
      if (this.$store.state.contributors.length === -1 || this.$store.state.loadContributors === false) {
        return '';
      }
      if (this.$store.state.contributors.length === 0) {
        return '';
      }
      var contributors = this.$store.state.contributors;
      var contributorsHtml = [];
      contributors.forEach(function (contributor) {
        contributorsHtml.push('<a href="' + contributor.html_url + '"><img src="' + contributor.avatar_url + '" width="100px;" style="max-width:100%;"><br><sub>' + contributor.login + '</sub></a><br><p>Contributions: ' + contributor.contributions + '</p>');
      });
      var row = 0;
      var returnString = '<h2>Contributors</h2>\n\n<table>';
      for (var i = 0; i < contributorsHtml.length; i += 1) {
        if (row === 0 && i % 6 === 0) {
          returnString += '<thead>';
        }
        if (row === 1 && i % 6 === 0) {
          returnString += '<tbody>';
        }
        if (i % 6 === 0) {
          returnString += '<tr>';
        }
        if (row === 0) {
          returnString += '<th align="center">' + contributorsHtml[i] + '</th>';
        } else {
          returnString += '<td align="center">' + contributorsHtml[i] + '</td>';
        }

        if (i % 6 === 6) {
          returnString += '</tr>';
          row += 1;
        }
        if (row === 0 && i % 6 === 5) {
          returnString += '<thead>';
        }
      }
      returnString += '</tbody></table>';
      return returnString;
    },
    finalMarkdown: function finalMarkdown() {
      var readme = '# ' + this.title + '\n\n' + this.shields + '\n\n' + this.showcase + '\n\n' + this.description + '\n\n' + this.dependencies + '\n\n' + this.installation + '\n\n' + this.howToUse + '\n\n' + this.examples + '\n\n' + this.contributing + '\n\n' + this.resourcesHeading + '\n\n' + this.motivation + '\n\n' + this.architecture + '\n\n' + this.documentation + '\n\n' + this.createLicenseText + '\n\n' + this.createContributorHtml + '\n\n' + this.linkToVueReadme + '\n';
      this.$store.commit('UPDATE_FINAL_MARKDOWN', readme);
      return readme;
    },
    finalHtml: function finalHtml() {
      return __WEBPACK_IMPORTED_MODULE_0_marked___default()(this.finalMarkdown);
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-r-button',
  props: {
    label: String,
    onClick: Function,
    disabled: Boolean
  },
  computed: {
    buttonClass: function getButtonClass() {
      if (this.disabled) {
        return 'disabled';
      }
      return '';
    }
  },
  methods: {
    defaultOnClick: function defaultOnClick(event) {
      if (this.onClick === undefined || this.disabled) {
        return;
      }
      this.onClick(event);
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_configuratorInput__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_configuratorInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_configuratorInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_configuratorTextarea__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_configuratorTextarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_configuratorTextarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_configuratorCheckbox__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_configuratorCheckbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_configuratorCheckbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_configuratorListAdd__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_configuratorListAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_configuratorListAdd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_configuratorShield__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_configuratorShield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_configuratorShield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_configuratorShowcase__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_configuratorShowcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_configuratorShowcase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_configuratorExamples__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_configuratorExamples___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_configuratorExamples__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_configuratorDocumentation__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_configuratorDocumentation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_configuratorDocumentation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_configuratorContact__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_configuratorContact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_configuratorContact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_readmePreview__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_readmePreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_readmePreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_vue_r_button__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_vue_r_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_vue_r_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_downloadModal__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_downloadModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_downloadModal__);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    'configurator-input': __WEBPACK_IMPORTED_MODULE_0__components_configuratorInput___default.a,
    'configurator-textarea': __WEBPACK_IMPORTED_MODULE_1__components_configuratorTextarea___default.a,
    'configurator-checkbox': __WEBPACK_IMPORTED_MODULE_2__components_configuratorCheckbox___default.a,
    'configurator-list-add': __WEBPACK_IMPORTED_MODULE_3__components_configuratorListAdd___default.a,
    'configurator-shield': __WEBPACK_IMPORTED_MODULE_4__components_configuratorShield___default.a,
    'configurator-showcase': __WEBPACK_IMPORTED_MODULE_5__components_configuratorShowcase___default.a,
    'configurator-examples': __WEBPACK_IMPORTED_MODULE_6__components_configuratorExamples___default.a,
    'configurator-documentation': __WEBPACK_IMPORTED_MODULE_7__components_configuratorDocumentation___default.a,
    'configurator-contact': __WEBPACK_IMPORTED_MODULE_8__components_configuratorContact___default.a,
    'readme-preview': __WEBPACK_IMPORTED_MODULE_9__components_readmePreview___default.a,
    'vue-r-button': __WEBPACK_IMPORTED_MODULE_10__components_vue_r_button___default.a,
    DownloadModal: __WEBPACK_IMPORTED_MODULE_11__components_downloadModal___default.a
  },
  data: function data() {
    return {
      showModal: false,
      dependencyName: '',
      dependencyVersion: ''
    };
  },

  computed: {
    license: {
      get: function get() {
        return this.$store.state.license;
      },
      set: function set(value) {
        this.$store.commit('UPDATE_LICENSE', value);
      }
    }
  },
  methods: {
    showModalFct: function showModalFct() {
      this.showModal = true;
    },
    loadContributors: function loadContributors() {
      this.$store.commit('UPDATE_CONTRIBUTORS');
    },
    adjustHeight: function test(event) {
      var textarea = event.srcElement;
      textarea.style.height = '1px';
      var lineHeight = parseInt(window.getComputedStyle(textarea)['line-height'], 10);
      textarea.style.height = lineHeight + textarea.scrollHeight + 'px';
    }
  }
});

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(28)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(59),
  /* scopeId */
  "data-v-2438111a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(37)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(68),
  /* scopeId */
  "data-v-7212e699",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(38)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(69),
  /* scopeId */
  "data-v-7b6b9b73",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(40)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(71),
  /* scopeId */
  "data-v-fb0b42c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(33)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(64),
  /* scopeId */
  "data-v-3dc6ac1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(31)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(62),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(36)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(67),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(26)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(57),
  /* scopeId */
  "data-v-0f981911",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(29)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(60),
  /* scopeId */
  "data-v-2532241a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(27)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(58),
  /* scopeId */
  "data-v-13bbbc92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(32)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(63),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(35)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(66),
  /* scopeId */
  "data-v-50e9da47",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "configurator-textarea"
  }, [(_vm.title !== undefined && _vm.title.length > 0) ? _c('h2', {
    staticClass: "configurator-textarea__heading",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectDescription),
      expression: "projectDescription"
    }],
    staticClass: "configurator-textarea__textarea",
    attrs: {
      "placeholder": _vm.placeholder,
      "rows": _vm.rows
    },
    domProps: {
      "value": (_vm.projectDescription)
    },
    on: {
      "keydown": _vm.adjustHeight,
      "keyup": _vm.adjustHeight,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.projectDescription = $event.target.value
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-wrapper pure-g",
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "pure-u-1 pure-u-md-1-3",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "pure-menu"
  }, [_c('a', {
    staticClass: "pure-menu-heading custom-brand",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("vue-readme")]), _vm._v(" "), _c('a', {
    staticClass: "custom-toggle",
    attrs: {
      "href": "#",
      "id": "toggle"
    }
  }, [_c('s', {
    staticClass: "bar"
  }), _c('s', {
    staticClass: "bar"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-1-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-1-3",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "pure-menu pure-menu-horizontal custom-menu-3 custom-can-transform"
  }, [_c('ul', {
    staticClass: "pure-menu-list"
  }, [_c('li', {
    staticClass: "pure-menu-item"
  }, [_c('a', {
    staticClass: "pure-menu-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "pure-menu-item"
  }, [_c('a', {
    staticClass: "pure-menu-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('li', {
    staticClass: "pure-menu-item"
  }, [_c('a', {
    staticClass: "pure-menu-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])])])])])])
}]}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "configurator-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticClass: "configurator-checkbox__input",
    attrs: {
      "type": "checkbox",
      "value": "None",
      "id": "squaredThree",
      "name": "check"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, "None") > -1 : (_vm.checked)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "None",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "configurator-checkbox__label",
    attrs: {
      "for": "squaredThree"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "configurator-checkbox__text-container"
  }, [_c('span', {
    staticClass: "configurator-checkbox__text",
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Download Markdown")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('textarea', {
    staticStyle: {
      "height": "80vh",
      "width": "100%"
    },
    domProps: {
      "textContent": _vm._s(this.$store.state.finalMarkdown)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-12"
  }, [_c('vue-r-button', {
    attrs: {
      "label": 'Download',
      "disabled": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-5-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-12"
  }, [_c('vue-r-button', {
    attrs: {
      "label": 'Close',
      "onClick": _vm.closeModal
    }
  })], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.buttonClass,
    domProps: {
      "textContent": _vm._s(_vm.label)
    },
    on: {
      "click": _vm.defaultOnClick
    }
  })
},staticRenderFns: []}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Badges")]), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-2 grid__padding--right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shieldName),
      expression: "shieldName"
    }],
    staticClass: "configurator__input",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.shieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shieldName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-2 grid__padding--left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shieldValue),
      expression: "shieldValue"
    }],
    staticClass: "configurator__input",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Value"
    },
    domProps: {
      "value": (_vm.shieldValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shieldValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shieldUrl),
      expression: "shieldUrl"
    }],
    staticClass: "configurator__input",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Url"
    },
    domProps: {
      "value": (_vm.shieldUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shieldUrl = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-3 grid__padding--right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shieldColor),
      expression: "shieldColor"
    }],
    staticClass: "configurator__input",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Color"
    },
    domProps: {
      "value": (_vm.shieldColor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shieldColor = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-2 grid__padding--left--right"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedShield),
      expression: "selectedShield"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedShield = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.shieldOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value,
        "textContent": _vm._s(option.text)
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-6 grid__padding--left"
  }, [_c('vue-button', {
    attrs: {
      "label": 'Add',
      "onClick": _vm.addShield
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markdown-container"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.finalHtml)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Dependencies")]), _vm._v(" "), _c('div', {
    staticClass: "dependency-shields-container"
  }, [_vm._l((_vm.dependencies), function(dependency) {
    return [_c('div', {
      staticClass: "pure-g dependency-list-container"
    }, [_c('div', {
      staticClass: "pure-u-1-8 delete-button"
    }, [_vm._v("X")]), _vm._v(" "), _c('div', {
      staticClass: "pure-u-7-12 dependency-list-container__name",
      domProps: {
        "textContent": _vm._s(dependency.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pure-u-7-24 dependency-list-container__version",
      domProps: {
        "textContent": _vm._s(dependency.version)
      }
    })])]
  }), _vm._v(" "), (_vm.dependencies.length !== 0) ? _c('div', {
    staticClass: "divider"
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "dependency-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependencyName),
      expression: "dependencyName"
    }],
    ref: "dependencyNameInput",
    staticClass: "dependency-name",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.dependencyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dependencyName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependencyVersion),
      expression: "dependencyVersion"
    }],
    staticClass: "dependency-version",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Version"
    },
    domProps: {
      "value": (_vm.dependencyVersion)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addDependency($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dependencyVersion = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('vue-r-button', {
    attrs: {
      "label": 'Add Dependency',
      "onClick": _vm.addDependency
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g"
  }, [(_vm.showModal) ? _c('download-modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-1-3 panel settings-panel",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "15px",
      "padding-right": "15px"
    }
  }, [_c('div', {
    staticClass: "configuration-panel"
  }, [_c('h2', [_vm._v("General Information")]), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-2",
    staticStyle: {
      "box-sizing": "border-box",
      "padding-right": "2px"
    }
  }, [_c('configurator-input', {
    attrs: {
      "placeholder": 'Project Title',
      "storeProperty": 'projectTitle',
      "storeCommitEvent": 'UPDATE_PROJECT_TITLE'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-2",
    staticStyle: {
      "box-sizing": "border-box",
      "padding-left": "2px"
    }
  }, [_c('configurator-input', {
    attrs: {
      "placeholder": 'Username',
      "storeProperty": 'username',
      "storeCommitEvent": 'UPDATE_USERNAME'
    }
  })], 1)]), _vm._v(" "), _c('configurator-shield'), _vm._v(" "), _c('configurator-showcase'), _vm._v(" "), _c('configurator-textarea', {
    attrs: {
      "title": 'Description',
      "placeholder": 'Describe your project',
      "rows": 2,
      "storeProperty": 'projectDescription',
      "storeCommitEvent": 'UPDATE_PROJECT_DESCRIPTION'
    }
  }), _vm._v(" "), _c('configurator-list-add'), _vm._v(" "), _c('configurator-textarea', {
    attrs: {
      "title": 'Installation',
      "placeholder": 'Provide Installation instructions',
      "rows": 2,
      "storeProperty": 'projectInstallation',
      "storeCommitEvent": 'UPDATE_INSTALLATION'
    }
  }), _vm._v(" "), _c('configurator-textarea', {
    attrs: {
      "title": 'How To Use',
      "placeholder": 'Describe on how to use the project',
      "rows": 2,
      "storeProperty": 'projectHowToUse',
      "storeCommitEvent": 'UPDATE_HOW_TO_USE'
    }
  }), _vm._v(" "), _c('configurator-examples'), _vm._v(" "), _c('div', [_c('configurator-textarea', {
    attrs: {
      "title": 'Contributing',
      "placeholder": 'Describe how people can contribute',
      "rows": 2,
      "storeProperty": 'contributing',
      "storeCommitEvent": 'UPDATE_CONTRIBUTING'
    }
  })], 1), _vm._v(" "), _c('div', [_c('h2', [_vm._v("Resources")]), _vm._v(" "), _c('h3', [_vm._v("Motivation")]), _vm._v(" "), _c('configurator-textarea', {
    attrs: {
      "placeholder": 'Describe what you motivated to start the project',
      "rows": 2,
      "storeProperty": 'motivation',
      "storeCommitEvent": 'UPDATE_MOTIVATION'
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Architecture")]), _vm._v(" "), _c('configurator-textarea', {
    attrs: {
      "placeholder": 'Give a summary of the architecture of your project',
      "rows": 2,
      "storeProperty": 'architecture',
      "storeCommitEvent": 'UPDATE_ARCHITECTURE'
    }
  }), _vm._v(" "), _c('configurator-documentation')], 1), _vm._v(" "), _c('configurator-contact'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('h2', [_vm._v("License")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.license),
      expression: "license"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.license = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("MIT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("BSD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("GPL")])])]), _vm._v(" "), _c('div', [_c('vue-r-button', {
    attrs: {
      "label": 'Load Contributors',
      "onClick": _vm.loadContributors
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('configurator-checkbox', {
    attrs: {
      "text": 'Link to this Project',
      "storeProperty": 'showVueReadme',
      "storeCommitEvent": 'UPDATE_SHOW_VUE_README'
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-1-2 panel readme-panel"
  }, [_c('readme-preview')], 1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-1-6 panel menu-panel",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "20px",
      "padding-right": "20px"
    }
  }, [_c('vue-r-button', {
    attrs: {
      "label": 'Create README.md',
      "onClick": _vm.showModalFct
    }
  })], 1), _vm._v(" "), _c('div')])], 1)
},staticRenderFns: []}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Showcase")]), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_vm._l((this.$store.state.showcaseImages), function(showcaseImage) {
    return [_c('div', {
      staticClass: "pure-u-1-8",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('div', {
      staticClass: "pure-u-7-8 truncate-overflow",
      staticStyle: {
        "box-sizing": "border-box"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(showcaseImage)
      }
    })])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-5-6 grid__padding--right"
  }, [_c('configurator-input', {
    ref: "inputField",
    attrs: {
      "placeholder": 'Add Image Url'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-6 grid__padding--left"
  }, [_c('vue-r-button', {
    attrs: {
      "label": 'Add',
      "onClick": _vm.addShowcaseImage
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Contact")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-2 grid__padding--left--right"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedShield),
      expression: "selectedShield"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedShield = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.shieldOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value,
        "textContent": _vm._s(option.text)
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-6 grid__padding--left"
  }, [_c('vue-button', {
    attrs: {
      "label": 'Add'
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-2 grid__padding--right"
  }, [_c('input', {
    staticClass: "configurator__input",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Platform"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-2 grid__padding--left"
  }, [_c('input', {
    staticClass: "configurator__input",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Url"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1-3 grid__padding--right"
  }, [_c('input', {
    staticClass: "configurator__input",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Color"
    }
  })])
}]}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Documentation")]), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-5-6 grid__padding--right"
  }, [_c('configurator-input', {
    ref: "documentationUrlInput",
    attrs: {
      "placeholder": 'Documentation Url'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-6 grid__padding--left"
  }, [_c('vue-r-button', {
    attrs: {
      "label": 'Add',
      "onClick": _vm.addDocumentationUrl
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.title !== undefined && _vm.title.length !== 0) ? _c('h2', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeValue),
      expression: "storeValue"
    }],
    staticClass: "configurator__input",
    attrs: {
      "spellcheck": "false",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.storeValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.storeValue = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Examples")]), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_vm._l((this.$store.state.examples), function(example) {
    return [_c('div', {
      staticClass: "pure-u-1-8",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('div', {
      staticClass: "pure-u-7-8 truncate-overflow",
      staticStyle: {
        "box-sizing": "border-box"
      }
    }, [_c('a', {
      attrs: {
        "href": example.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(example.name)
      }
    })])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-3-8 grid__padding--right"
  }, [_c('configurator-input', {
    ref: "inputName",
    attrs: {
      "placeholder": 'Name'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-5-8 grid__padding--left"
  }, [_c('configurator-input', {
    ref: "inputUrl",
    attrs: {
      "placeholder": 'Url'
    }
  })], 1), _vm._v(" "), _c('vue-r-button', {
    attrs: {
      "label": 'Add Example',
      "onClick": _vm.addExample
    }
  })], 1)])
},staticRenderFns: []}

/***/ })
],[8]);


// WEBPACK FOOTER //
// static/js/app.2a77109713ea5b7c0c92.js